import styled from 'styled-components';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';

const overlapping = 240;

export default styled(FullWidthPageContent)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  background-color: ${({ theme }) => theme.palette.background.primary};
  padding: ${({ theme }) => theme.spacing * 2}px;
  padding-bottom: ${overlapping}px;
  margin-bottom: -${overlapping}px !important;
`;
